import { RouteRecordRaw } from 'vue-router';
import { useNotificationsStore } from '@/stores';
import { AppPermissions } from '@/shared/permissions';
import { AppCoreEnums } from 'src/core/shared/enums';
import usePermissionChecker from '@/core/composable/use-permission-checker';
import { ResolveParams, IRouteMeta } from 'src/core/models/routing';

const ROUTE_NOTIFICATIONS_ROOT = 'notifications-root';
const ROUTE_NOTIFICATIONS = 'notifications';

const notificationsRoutes: RouteRecordRaw = {
  name: ROUTE_NOTIFICATIONS_ROOT,
  path: ROUTE_NOTIFICATIONS,
  component: () => import('src/core/containers/empty-container.vue'),
  meta: <IRouteMeta>{
    containerType: AppCoreEnums.ContainerType.EmptyContainer,
    permissions: { readPermission: AppPermissions.NotificationsRead },
  },
  redirect: { name: ROUTE_NOTIFICATIONS },
  children: [
    {
      name: ROUTE_NOTIFICATIONS,
      path: 'list',
      component: () => import('src/pages/notifications/notifications-page.vue'),
      meta: <IRouteMeta>{
        resolve: (resolveParams: ResolveParams) => {
          const { hasPermission } = usePermissionChecker();
          const canManage =
            hasPermission(AppPermissions.NotificationsWrite) || hasPermission(AppPermissions.NotificationsDelete);
          return canManage
            ? Promise.all([useNotificationsStore().initAdminView()])
            : Promise.all([useNotificationsStore().initUserView()]);
        },
        permissions: {
          readPermission: AppPermissions.NotificationsRead,
          writePermission: AppPermissions.NotificationsWrite,
          deletePermission: AppPermissions.NotificationsDelete,
        },
        containerType: AppCoreEnums.ContainerType.CollapsibleTableContainer,
      },
    },
  ],
};

export { notificationsRoutes, ROUTE_NOTIFICATIONS, ROUTE_NOTIFICATIONS_ROOT };
